import getClient from '../../client';
const details = 'DASHBOARD::DETAILS';
const deviceType = 'DASHBOARD::DEVICE_TYPE';
const equipmentType = 'DASHBOARD::EQUIPMENT_TYPE';
const items = 'DASHBOARD::ITEMS';
const isTransition = 'DASHBOARD::IS_TRANSITION';
const loading = 'DASHBOARD::LOADING';
const softwareNumber = 'DASHBOARD::SOFTWARE_NUMBER';

/* eslint-disable camelcase */
const localhostDashboardItems = [
  {
    title: 'Paris City Run, France',
    id: '59b1c1dc8f3a770041dbd6f1',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/2d2b5530941811e7951917cc4c84e6a7.jpg',
    workout_id: '59139e246b83fe001f2bada6',
    user_type: 'premium'
  },
  {
    title: 'Lake Louise, Alberta, Canada',
    id: '59b1c20e50d26b0040ea3ea4',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/8fa7a2d094e111e79d1d8f7942262348.jpg',
    workout_id: '57ec4b4e55fb5428005eab2f',
    user_type: 'premium'
  },
  {
    title: 'Hellbrunn Palace Run, Salzburg, Austria ',
    id: '59b1c2368f3a770041dbd6f2',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/630271c0941811e79c6e13e39a023478.png',
    workout_id: '594d558c954dcf00203f4b26',
    user_type: 'premium'
  },
  {
    id: '58223de97209e21f00ae42a1',
    type: 'navigation',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/f4504d20a5f611e6a69c55a226387a74.png',
    description: 'Explore your list of favorite workouts.',
    title: 'My Favorites',
    navigation_type: 'Favorites',
    user_type: 'all'
  },
  {
    id: '58223e103d0aec1e0058dd49',
    type: 'navigation',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/0667c3f098ac11e7a42f0f56faf2e00e.jpg',
    description: 'Discover your perfect workout from an ever-growing collection.',
    title: 'Browse the workout library',
    navigation_type: 'Library',
    user_type: 'premium'
  },
  {
    title: 'Jack\'s Point Walk, Queenstown, New Zealand',
    id: '59b1c256414fab003fcaa1c0',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/74772220941811e794231990db38fede.png',
    workout_id: '5936e62986f4e90024bc3842',
    user_type: 'premium'
  },
  {
    title: 'Shipwreck Beach Tempo Run, Studio Class',
    id: '59b1c28b50d26b0040ea3ea5',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/95acb860941811e7914db717c3e5ec8e.png',
    workout_id: '589bcfc087d01c1d006b8cf0',
    user_type: 'premium'
  },
  {
    title: 'Waterline Road, Flagstaff, Arizona',
    id: '59b1c2c99ff6ba0045b1f28c',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/b9d1f480941811e78d638bb2dc36f40e.jpg',
    workout_id: '597a07da0eefb80025dac51c',
    user_type: 'premium'
  },
  {
    title: 'Boulders Beach Walk, Cape Town, South Africa',
    id: '59b1c2ed414fab003fcaa1c1',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/cf971340941811e78d638bb2dc36f40e.jpg',
    workout_id: '58d949fc210f191e00e6b8dd',
    user_type: 'premium'
  },
  {
    title: 'Killarney National Park, Ireland',
    id: '59b1c311414fab003fcaa1c2',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/e50bef20941811e798d3551e0816dea8.png',
    workout_id: '58d03a03ad756921008f769f',
    user_type: 'premium'
  },
  {
    title: 'North Shore Beach, Hawaii',
    id: '59b1c338414fab003fcaa1c3',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/fc754800941811e7914db717c3e5ec8e.png',
    workout_id: '58fa8c7c3901de001ec8c09d',
    user_type: 'premium'
  },
  {
    title: 'Lake Louise, Alberta',
    id: '59b1c3569ff6ba0045b1f28d',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/0e29e790941911e784d14b2885a761bf.png',
    workout_id: '5894ce6cac49122400000370',
    user_type: 'premium'
  },
  {
    title: 'Dupont State Park, North Carolina',
    id: '59b1c3748f3a770041dbd6f3',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/1ee81930941911e7902671dbced8c607.png',
    workout_id: '58b0b7ea567671290027bac9',
    user_type: 'premium'
  }
];
/* eslint-enable camelcase */

function removeFavorites(workouts) {
  return workouts.filter((workout) => {
    if (workout.type && workout.type.toLowerCase() === 'navigation' && workout.navigation_type && workout.navigation_type.toLowerCase() === 'favorites') {
      return false;
    }
    return true;
  });
}

function getCardData() {
  if (window.environment === 'local') {
    return (dispatch, getState) => {
      dispatch(setItems(localhostDashboardItems));
    };
  }
  return (dispatch, getState) => {
    const { softwareNumber, equipmentType, deviceType } = getState().dashboard;
    const client = getClient();
    if (!client) return dispatch(setItems(null));
    if (equipmentType) {
      Promise.all([
        client.WorkoutOfTheDay.get(equipmentType, softwareNumber || 0),
        client.EquipmentFeaturedContent.get(softwareNumber || 0, equipmentType)
      ])
        .then(results => [results[0].data, ...results[1].data])
        .then(items => (deviceType === 'mobile'
          ? removeFavorites(items)
          : items)
        )
        .then(items => dispatch(setItems(items)));
    } else {
      client.EquipmentFeaturedContent.get(softwareNumber || 0, 'all')
        .then(workouts => (deviceType === 'mobile'
          ? removeFavorites(workouts.data)
          : workouts.data))
        .then(workouts => dispatch(setItems(workouts)));
    }
  };
}

function setDetails(value) {
  return {
    type: details,
    value
  };
}

function setDeviceType(value) {
  return {
    type: deviceType,
    value
  };
}

function setEquipmentType(value) {
  return {
    type: equipmentType,
    value
  };
}

function setIsTransition(value) {
  return {
    type: isTransition,
    value
  };
}

function setSoftwareNumber(value) {
  return {
    type: softwareNumber,
    value
  };
}

function setItems(value) {
  return {
    type: items,
    value
  };
}

export default {
  details,
  deviceType,
  equipmentType,
  items,
  isTransition,
  loading,
  softwareNumber,
  getCardData,
  setDetails,
  setDeviceType,
  setEquipmentType,
  setItems,
  setIsTransition,
  setSoftwareNumber
};


// WEBPACK FOOTER //
// ./src/views/dashboard/actions.js